import { render, staticRenderFns } from "./kbbb.vue?vue&type=template&id=8d0e8a84"
import script from "./kbbb.vue?vue&type=script&lang=js"
export * from "./kbbb.vue?vue&type=script&lang=js"
import style0 from "./kbbb.vue?vue&type=style&index=0&id=8d0e8a84&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports